import React from 'react';
import LsLoader from 'atoms/LsLoader/LsLoader';
import { Link } from 'react-router-dom';

import { CARET_RIGHT, CARET_DOWN } from '../../common/imagePath';

import { getCheckedData } from '../../utils/helper';

const renderContent = (props, audFilter, index) => {
  const {
    name,
    checkedFilters,
    audienceSubFilter,
    _handleOnCheckBoxClick,
    _handleOnAudienceSubFilter,
    _handleSectionSelectAll,
    _handleRemove,
    filteredValues,
  } = props;

  audFilter['filterAudienceDataList']?.sort((a, b) =>
    a.filterName > b.filterName ? 1 : -1
  );

  return (
    <div key={index}>
      <div
        className="panel-heading d-flex align-items-center justify-content-between mb-3"
        onClick={() => _handleOnAudienceSubFilter(audFilter.filterName)}
      >
        <div className="d-flex align-items-center">
          <img
            src={
              audienceSubFilter && audienceSubFilter[audFilter.filterName]
                ? CARET_DOWN
                : CARET_RIGHT
            }
            alt="list_icon"
          />
          <p className="panel-title">{audFilter.filterName}</p>
        </div>
        <div className="d-flex align-items-center">
          <span
            className="select_all section_menu ml-2"
            onClick={(e) => {
              e.stopPropagation();
              _handleSectionSelectAll(
                name,
                audFilter.filterName,
                audFilter['filterAudienceDataList']
              );
              _handleOnAudienceSubFilter(
                audFilter.filterName,
                audFilter.children,
                'selectAll'
              );
            }}
          >
            Select All
          </span>
          <span
            className="select_all section_menu ml-1 mr-1"
            onClick={(e) => {
              e.stopPropagation();
              _handleRemove(
                name,
                name === 'interests'
                  ? filteredValues.filteredValues.id[index].filterName ===
                    'CUSTOM POI'
                    ? 'POI_PACKAGE'
                    : filteredValues.filteredValues.id[index].filterName
                  : filteredValues.filteredValues.id[index].filterId
              );
              _handleOnAudienceSubFilter(
                audFilter.filterName,
                audFilter.children,
                'clear'
              );
            }}
          >
            Clear
          </span>
        </div>
      </div>
      {audienceSubFilter && audienceSubFilter[audFilter.filterName] && (
        <ul className="side_tab_modal_list">
          {audFilter['filterAudienceDataList']?.map((listData, index) => {
            return (
              <li key={index}>
                <div className="cstm_tab_checkbox">
                  <input
                    type="checkbox"
                    id={listData.filterId}
                    onChange={(event) =>
                      _handleOnCheckBoxClick(
                        event,
                        listData,
                        name,
                        listData.filterName
                      )
                    }
                    checked={
                      name === 'interests'
                        ? getCheckedData(
                            listData,
                            checkedFilters['interests'] &&
                              checkedFilters['interests']
                              ? checkedFilters['interests']
                              : []
                          )
                        : getCheckedData(
                            listData,
                            checkedFilters['geography'] &&
                              checkedFilters['geography']
                              ? checkedFilters['geography']
                              : []
                          )
                    }
                  />
                  <label htmlFor={listData.filterId}></label>
                  <p>{listData.filterName}</p>
                </div>
                <Link to="#"></Link>
              </li>
            );
          })}
          {audFilter.children &&
            audFilter.children.map((audFilData, i) => {
              return renderContent(props, audFilData, i);
            })}
        </ul>
      )}
    </div>
  );
};

const PoiGeographyFilters = (props) => {
  const { filteredValues } = props;
  if (
    props?.poiPackages?.poiPackage?.length > 0 &&
    props?.poiPackages?.poiPackageStatus === 'success' &&
    !filteredValues?.filteredValues?.id?.find(
      (filteredValue) => filteredValue?.filterName === 'CUSTOM POI'
    )
  ) {
    filteredValues?.filteredValues?.id?.push({
      filterName: 'CUSTOM POI',
      filterAudienceDataList: [...props.poiPackages.poiPackage],
    });
  }
  return (
    <div className="panel-group">
      <div className="panel panel-default">
        {filteredValues.changingStatus === 'success' &&
        filteredValues.filteredValues.status &&
        filteredValues.filteredValues.id &&
        filteredValues.filteredValues.id.length ? (
          filteredValues.filteredValues.id.map((audFilter, index) => {
            if(!(props.type === 'geography' && audFilter.filterName === 'CUSTOM POI')){
              return renderContent(props, audFilter, index);
            }
          })
        ) : filteredValues.changingStatus === 'success' &&
          filteredValues.filteredValues.status &&
          (!filteredValues.filteredValues.id ||
            !filteredValues.filteredValues.id.length) ? (
          'No results'
        ) : (
          <LsLoader />
        )}
      </div>
    </div>
  );
};

export default PoiGeographyFilters;
